var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");

var Editor2DModel = function (showUI, heavyHandler) {
    var self = this;
    lib_core.Model.call(this);

    // state
    this.state = this.value("state", true);
    this.showUI = this.value("showUI", true);   // TODO: shouldn't be a model field!
    this.thumbnailCanvas = this.value("thumbnailCanvas", true); // TODO: shouldn't be a model field!

    // type
    this.type  = this.value("type", true);  // TODO: shouldn't be a model field!

    // coarseness: the approximate grid distance when the editor loads in default mode
    // especially important to have a correct relative value between the different editors
    // used to calculate geometry precision
    this.coarseness  = this.value("coarseness", true);  // TODO: shouldn't be a model field?

    // interaction models
    this.interactionModelDataMap = this.map("interactionModels", true); // TODO: this has the same name as interactionModels!!
    this.interactionModels = this.shadow("interactionModels",    // TODO: why is this necessary?
        function () {
            var result = new lib_core.Collections.HashSet();
            self.interactionModelDataMap.forEach(function(data, interactionModel) {
                result.add(interactionModel);
            });
            return result;
        },
        null,
        [this.interactionModelDataMap]
    );

    // canvas dimension and absolute position
    this.canvasRect = this.value("canvasRect", true);

    // last mouse position
    this.mousePos = this.value("mousePos", true);
    this.mouseDisplacement = this.value("mouseDisplacement", true);

    // init: TODO: necessary?
    this.showUI(showUI);
    //the boundingbox of the canvas object in the coordinate system of the browser
    this.canvasRect(new lib_geometry.BoundingBox(0, 0, 0, 0));
    this.mousePos(new lib_geometry.Coord(0,0));
    this.mouseDisplacement( new lib_geometry.Coord(0,0));

    this.heavyHandler = heavyHandler;
};
lib_core.inherit(Editor2DModel, lib_core.Model);
lib_core.JsonParser.registerClass(Editor2DModel, "Editor2DModel");

module.exports = Editor2DModel;

//accepts a value in the coordinate system of the browser and transforms it into the coordinate system of the canvas object
Editor2DModel.prototype.getRelativeMouseCoord = function (event) {
    return new lib_geometry.Coord(event.pageX-this.canvasRect().x, event.pageY-this.canvasRect().y);
};

Editor2DModel.prototype.getInteractionModelsAtPos = function(pos) {
    return this.interactionModels().filter(function(im){
        if(im.data.boundingBox)
            return pos.containedByBB(im.data.boundingBox());
        else
            return false;
    });
};

Editor2DModel.prototype.getSnappedMousePos = function() {
    // can be overwritten for interface with snap
    return this.mousePos();
};

Editor2DModel.prototype.getSnappedMouseDisplacement = function() {
    // can be overwritten for interface with snap
    return this.mouseDisplacement();
};

Editor2DModel.prototype.getSnapVec = function() {
    // can be overwritten for interface with snap
    return this.mouseDisplacement();
};

Editor2DModel.prototype.clearSnap = function() {
    // can be overwritten for interface with snap
};

Editor2DModel.prototype.geometryPrecision = function() {
    return this.coarseness() * 5e-3;
};
